import { Badge } from "@material-ui/core";

export default Badge;
